import React from 'react'

import LandingPage from '../LandingPage/LandingPage';
import Counter from '../Counter/Counter';
import HowToMint from '../HowToMint/HowToMint';
import AboutSection from '../AboutSection/AboutSection';

import BitSli from '../BitSli/BitSli';

export default function HomePage() {
  return (
    <div>

         <LandingPage/>
    <Counter/>
    <BitSli/>
    <HowToMint/>
     <AboutSection/> 
    </div>
  )
}
